<script>
    export let mod_index, updateCallback, values;
    import Text_field from "../util/Text_field.svelte"
    import Text_area from "../util/Text_area.svelte"
    import Select from 'svelte-select';
    
    let genres = [
        {value:"Literary Fiction", label:"Literary Fiction"},
        {value:"Speculative Fiction", label:"Speculative Fiction"},
        {value:"Science Fiction", label:"Science Fiction"},
        {value:"Fantasy", label:"Fantasy"},
        {value:"Mystery", label:"Mystery"},
        {value:"Thriller", label:"Thriller"},
        {value:"Horror", label:"Horror"},
        {value:"Romance", label:"Romance"},
        {value:"Western", label:"Western"},
        {value:"Dystopian", label:"Dystopian"},
        {value:"Bildungsroman", label:"Bildungsroman"},
        {value:"Historical", label:"Historical"},
        {value:"Realist Literature", label:"Realist Literature"},
        {value:"Magical Realism", label:"Magical Realism"}
    ];

    function handleSelect(event) {
        //console.log('selected item', event.detail);
        updateCallback(mod_index, 'genre', event.detail.value)//event.detail is just the object in genres, so this can be expanded in the future for more generic use, but rn i dont like what it writes to console, even though it does work right.
    }
    
</script>

<div class="module">
    <div class="grid">
        <h1 class="title">Story meta information</h1>
        <div class="line"></div>
        <div class="select">
            <!--<h1>Genre</h1>-->
            <Select items={genres} placeholder="Select genre..." on:select={handleSelect}></Select>
        </div>
        <!--        
            <Text_field align='end' placeholder='Genre' value={values.genre} area='genre' index={mod_index} field_store_name='genre' updateCallback={updateCallback}></Text_field>
-->
        <Text_field align='end' placeholder='Character count' value={values.chars} area='chars' index={mod_index} field_store_name='chars' updateCallback={updateCallback}></Text_field>
        <Text_field align='end' placeholder='Time frame' value={values.time} area='time' index={mod_index} field_store_name='time' updateCallback={updateCallback}></Text_field>
        <Text_area placeholder='Story promise' value={values.promise} area='promise' index={mod_index} field_store_name='promise' updateCallback={updateCallback}></Text_area>
        <Text_area placeholder='Story resolve • goal • catharsis' value={values.resolve} area='resolve' index={mod_index} field_store_name='resolve' updateCallback={updateCallback}></Text_area>
        <Text_area placeholder='Story progress outline' value={values.progress} area='progress' index={mod_index} field_store_name='progress' updateCallback={updateCallback}></Text_area>

    
    </div>
</div>

<style lang="scss">
    @use "styles/global.scss";

    .module{
        @include module;
        
        .grid{
            //width: 80%;
            min-width: 600px;
            min-height: 300px;
            width: 1022px;
            height: 576px;

            display: grid;
            grid-template-columns: 224px auto auto;
            grid-template-rows: 50px 50px 50px 50px auto;
            grid-template-areas: 
                "title title title"
                "genre promise resolve"
                "chars promise resolve"
                "time promise resolve"
                "progress progress progress"
            ;
            gap: 12px;
        }

        .select{
            grid-area: genre;
            width: 100%;
            height: auto;
            justify-self: start;
            margin-top: 1em;

            @include svelte_select;
        }

        .title{
            @include module_title;
        }

        .line{
            grid-area: title;
            @include line($size:50%, $thicc:2px);
        }
    }
</style>